import * as Yup from 'yup';

export const vesselTyoeValidationSchema = Yup.object().shape({
  name: Yup.string().required('The vessel type name is required'),
  volume: Yup.number().required('The vessel type volume is required'),
  quantity: Yup.number().required('The vessel type quantity is required')
});



// WEBPACK FOOTER //
// ./src/validation/vesselType.js